export const AppConfig = {
    stripeToken:
        process.env.NODE_ENV === "production"
            ? "pk_live_t7Kl1zBCn1HDreBi6MABv2hi"
            : "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",
    stripeTestToken: "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",

};
